import { getTotalPrice } from '@shared/lib/money';
import { GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment } from '@websky/graphql';
import { Money } from '../../Money/types';
import { TravellerWithServices } from './types';

export const getAnimalTotalPrice = (
	services: GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment[],
	travellers: TravellerWithServices[],
	withoutUnconfirmed = false
) => {
	const selectedServicePrices: Money[] = [];

	services.forEach(service => {
		const allowedPassengerIds = new Set(service.allowedPassengers.reduce((acc, ids) => [...acc, ...ids], []));

		travellers?.forEach(traveller => {
			if (allowedPassengerIds.has(traveller.id)) {
				traveller?.services?.gdsServices?.services?.forEach(selectedService => {
					if (
						selectedService.serviceId === service.id &&
						(!withoutUnconfirmed || (withoutUnconfirmed && selectedService.confirmedCount === 0))
					) {
						selectedServicePrices.push({
							...service.price,
							amount: service.price.amount * selectedService.segmentIds.length
						});
					}
				});
			}
		});
	});

	return getTotalPrice(selectedServicePrices, price => price);
};
